// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var GraphQLConverter = require("../../common/GraphQLConverter.bs.js");

function decode(obj) {
  var partial_arg = GraphQLConverter.Helpers.some(obj.state)("missing state");
  var partial_arg$1 = GraphQLConverter.Helpers.some(obj.zip)("missing zip");
  var partial_arg$2 = GraphQLConverter.Helpers.some(obj.city)("missing city");
  var partial_arg$3 = function (param) {
    return GraphQLConverter.Helpers.flatMap((function (param) {
                  return GraphQLConverter.Helpers.source(obj, param);
                }), partial_arg$2, param);
  };
  var partial_arg$4 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$3, partial_arg$1, param);
  };
  return GraphQLConverter.Helpers.run(function (city, zip, state) {
                return {
                        city: city,
                        zip: zip,
                        state: state
                      };
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap(partial_arg$4, partial_arg, param);
            });
}

var ppx_printed_query = "fragment StandardizedAddress on StandardizedAddress   {\ncity  \nzip  \nstate  \n}\n";

function parse(value) {
  var value$1 = Js_json.decodeObject(value);
  var tmp;
  if (value$1 !== undefined) {
    var value$2 = Caml_option.valFromOption(value$1);
    var value$3 = Js_dict.get(value$2, "city");
    var field_city = value$3 !== undefined && !(value$3 == null) ? value$3 : undefined;
    var value$4 = Js_dict.get(value$2, "zip");
    var field_zip = value$4 !== undefined && !(value$4 == null) ? value$4 : undefined;
    var value$5 = Js_dict.get(value$2, "state");
    var field_state = value$5 !== undefined && !(value$5 == null) ? value$5 : undefined;
    tmp = {
      city: field_city,
      zip: field_zip,
      state: field_state
    };
  } else {
    tmp = Js_exn.raiseError("Unexpected GraphQL query response");
  }
  return decode(tmp);
}

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var StandardizedAddress = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  name: "StandardizedAddress",
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var Fragments = {
  StandardizedAddress: StandardizedAddress
};

var Fragment;

exports.decode = decode;
exports.Fragments = Fragments;
exports.Fragment = Fragment;
/* GraphQLConverter Not a pure module */
